import type { VfConfig } from '#types/config/components/vf'

export default {
  alwaysUseGrid: true,
  brandClasses: {
    carousel: 'lg:(pl-6 gap-1)',
    pagination: 'lg:hidden'
  }
} satisfies VfConfig['mediaGallery']
